import { Priority, MessageStatus, TelecomBrandStatus } from '../api/telecom.api';

/**
 * Priority enum display name mappings
 */
export const priorityDisplayNames: Record<Priority, string> = {
    [Priority.Low]: 'Low',
    [Priority.Normal]: 'Normal',
    [Priority.High]: 'High',
    [Priority.Urgent]: 'Urgent',
};

/**
 * Message status enum display name mappings
 */
export const messageStatusDisplayNames: Record<MessageStatus, string> = {
    [MessageStatus.Scheduled]: 'Scheduled',
    [MessageStatus.Sent]: 'Sent',
    [MessageStatus.SendingError]: 'Sending Error',
    [MessageStatus.Delivered]: 'Delivered',
    [MessageStatus.DeliveryError]: 'Delivery Error',
    [MessageStatus.Sending]: 'Sending',
};

/**
 * TCR brand status enum display name mappings
 */
export const telecomBrandStatusDisplayNames: Record<TelecomBrandStatus, string> = {
    [TelecomBrandStatus.NotSynced]: 'Not Synced',
    [TelecomBrandStatus.ScorePending]: 'Score Pending',
    [TelecomBrandStatus.Active]: 'Active',
    [TelecomBrandStatus.Removed]: 'Removed',
    [TelecomBrandStatus.VettingPending]: 'Vetting Pending',
};

/**
 * Get display name for Priority enum
 */
export const getPriorityDisplayName = (priority: Priority): string => {
    return priorityDisplayNames[priority] ?? `Priority ${priority}`;
};

/**
 * Get display name for MessageStatus enum
 */
export const getMessageStatusDisplayName = (status: MessageStatus): string => {
    return messageStatusDisplayNames[status] ?? `Status ${status}`;
};

/**
 * Get display name for TelecomBrandStatus enum
 */
export const getTelecomBrandStatusDisplayName = (status: TelecomBrandStatus): string => {
    return telecomBrandStatusDisplayNames[status] ?? `Status ${status}`;
};
